<script>
import BaseLayout from './base_layout.vue';

const IndexLayout = {
  ...BaseLayout,
  name: 'IndexLayout',
};

export default IndexLayout;
</script>
